/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL3JlcXVlc3Qtc3VwcG9ydC9yZXF1ZXN0LXN1cHBvcnQtYnV0dG9uLmNvbXBvbmVudC5zY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci93d3cvZG5hdGEtY2VyZi1mcm9udC1lbmQvcmVsZWFzZXMvMjAyMDAzMjYxNjEyMzMvc3JjL2FwcC9tb2R1bGVzL3V0aWxpdGllcy9jb21wb25lbnRzL3JlcXVlc3Qtc3VwcG9ydC9yZXF1ZXN0LXN1cHBvcnQtYnV0dG9uLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/$$_gendir/app/modules/utilities/components/request-support/request-support-button.component.scss.shim.ngstyle.ts